'use client';

import { Configure, Hits, RefinementList } from 'react-instantsearch';
import Link from 'next/link';
import { DAYS_OF_WEEK, MONTHS } from 'constants/date';
import * as styles from './AlgoliaSearchDropdown.css';

type AlgoliaSearchDropdownProps = {
  isDropdownOpen: boolean;
};

interface IHit {
  name: string;
  city: string;
  state: string;
  images: {
    lg: string;
    original: string;
    xs: string;
  };
  start_date: number;
  end_date: number;
  event_url: string;
}

function Hit({ hit }: { hit: IHit }) {
  const formatDate = (timestamp: number) => {
    const dateObject = new Date(timestamp * 1000);

    const dayOfWeek = DAYS_OF_WEEK[dateObject.getDay()];
    const dayOfMonth = dateObject.getDate();
    const month = MONTHS[dateObject.getMonth()];
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();

    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    const formattedDate = `${dayOfWeek}, ${dayOfMonth} ${month} as ${formattedHours}h${formattedMinutes}`;
    return formattedDate;
  };

  return (
    <Link href={hit.event_url} className={styles.HitItem}>
      <div className={styles.HitImageWrapper}>
        <img
          src={hit.images.original}
          alt={hit.name}
          className={styles.HitImage}
        />
      </div>

      <div className={styles.HitContent}>
        <h3 className={styles.HitTitle}>
          {hit.name}
        </h3>
        <p className={styles.HitSubtitle}>
          {hit.city}
          {' '}
          -
          {' '}
          {hit.state}
        </p>
        <p className={styles.HitDate}>
          {formatDate(hit.start_date)}
        </p>
      </div>
    </Link>
  );
}

function AlgoliaSearchDropdown({
  isDropdownOpen,
}: AlgoliaSearchDropdownProps) {
  const dropdownContainerClasses = `${styles.dropdownWrapper} ${isDropdownOpen ? styles.dropdownVisible : styles.dropdownHidden}`;

  return (
    <div className={dropdownContainerClasses}>
      <Configure hitsPerPage={5} />
      <RefinementList attribute="name" />
      <Hits
        classNames={{
          list: styles.HitsList,
        }}
        hitComponent={Hit}
      />
    </div>
  );
}

export default AlgoliaSearchDropdown;
